<template>
  <a-spin :spinning="loading" tip="加载中...">
    <div :style="{ height }">
      <iframe
        :src="src"
        frameborder="no"
        style="width: 100%; height: 100%"
        scrolling="auto"
      />
    </div>
  </a-spin>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

const src = ref('https://fga.setworld.net/')
const height = ref(document.documentElement.clientHeight - 130 + 'px')
const loading = ref(true)

function resize() {
  height.value = document.documentElement.clientHeight - 130 + 'px'
}

onMounted(() => {
  setTimeout(() => {
    loading.value = false
  }, 230)
  window.addEventListener('resize', resize)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', resize)
})
</script>
